<h1 mat-dialog-title>Dodaj nowego dostawcę</h1>
<mat-dialog-content>
  <form [formGroup]="form" class="flex flex-col">
    <mat-form-field appearance="outline">
      <mat-label>Nazwa dostawcy</mat-label>
      <div class="flex justify-start">
        <input type="text" matInput formControlName="biller" [matAutocomplete]="auto" />
        <app-icon name="arrow_drop_down" size="20"></app-icon>
      </div>

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let biller of filteredOptions$ | async" [value]="biller">
          {{ biller.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <button mat-raised-button color="accent" [appApiCallLoading]="submit" [disabled]="this.form.invalid">Dodaj</button>
  <button mat-button matDialogClose>Anuluj</button>
</mat-dialog-actions>
